import { ChangeDetectionStrategy, Component, computed, input, Signal } from '@angular/core';
import { TiimeSecondaryFiltersModule, TiimeButtonToggleModule } from 'tiime-material';
import { AccountingPeriod } from '@models/accounting-period';
import { DocumentRequestStatusEnum } from '@enums/document-request-status.enum';
import { DocumentRequestFiltersForm } from '@forms/document-request-filters-form';
import { ReactiveFormsModule } from '@angular/forms';
import { AccountingPeriodSelectComponent } from '@shared-selectors/accounting-period-select/accounting-period-select.component';
import { ResetButtonComponent } from '@shared-components/reset-button/reset-button.component';
import { DocumentRequestFilters } from '@interfaces/document-request-filters';

@Component({
  selector: 'app-document-request-filters-button',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TiimeButtonToggleModule,
    TiimeSecondaryFiltersModule,
    AccountingPeriodSelectComponent,
    ResetButtonComponent
  ],
  templateUrl: './document-request-filters-button.component.html',
  styleUrl: './document-request-filters-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentRequestFiltersButtonComponent {
  readonly accountingPeriods = input.required<AccountingPeriod[]>();
  readonly form = input.required<DocumentRequestFiltersForm>();
  readonly filters = input.required<DocumentRequestFilters>();
  protected readonly DocumentRequestStatusEnum = DocumentRequestStatusEnum;

  readonly badgeNumber: Signal<number> = computed(() => {
    const filters = this.filters();
    let badgeNumber = 0;
    if (filters.documentRequestStatus !== 'all') {
      badgeNumber++;
    }
    if (filters.accountingPeriod !== null) {
      badgeNumber++;
    }
    return badgeNumber;
  });

  reset(): void {
    this.form().patchValue({
      accountingPeriod: null,
      documentRequestStatus: 'all'
    });
  }
}
